<template>
    <time :datetime="date|formatDate('YYYY-MM-DD')">{{ date|formatDate('DD MMMM YYYY', language) }}</time>
</template>

<script>
    export default {
        props: {
            date: {
                type: Number,
                required: true,
            },
            language: {
                type: String,
                required: true,
            },
        },
    };
</script>
